<template>
  <div class="dialog-container dialog-light">
    <div class="dialog dialog-md">
      <!-- header few more detail -->
      <ax-dialog-header
        text="A few more details"
        :type="'details'"
        :description="'Tell us a bit more about your organisation'"
      ></ax-dialog-header>
      <!-- Business information step -->
      <div class="dialog-body">
        <div class="businessDetails-form">
          <div>
            <div class="form-group">
              <k-dropdown-list
                  :label="'Your business industry*'"
                  :data-items="industries"
                  :data-item-key="'businessIndustryID'"
                  :text-field="'businessIndustryName'"
                  v-model="businessDetails.businessIndustry"
                  ref="ddlIndustry"
                  @change="validateIndustryOnChange"
                  v-kendo-validator="validateIndustry()"
              >
              </k-dropdown-list>
            </div>
            <div class="form-group">
              <k-input
                class=""
                label="Business name*"
                v-model="businessDetails.businessName"
                ref="businessNameInput"
                @change="validateNameOnChange"
                v-kendo-validator="validateBusinessName()"
            ></k-input>
            </div>
            <div class="form-group mt-4">
              <div class="row">
                <div class="col-12">
                  <div class="d-flex">
                    <k-checkbox
                      label="Business is GST Exempt"              
                      v-model="businessDetails.gstExclusive"
                      :disabled="businessDetails.businessIndustry?.incomeTaxExempted"
                      size="large"
                      class="white-checkbox"
                    />
                    <PromptIcon content="If enabled, your cost of goods sold, and other revenue will not have GST applied." />
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <div class="d-flex">
                    <k-checkbox
                      label="Other Income has GST"
                      v-model="businessDetails.otherIncomeHasGST"
                      :disabled="businessDetails.businessIndustry?.incomeTaxExempted"
                      size="large"
                      class="white-checkbox"
                    />
                    <PromptIcon content="If enabled, your other income will have GST applied." />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4" v-show="false">
            <h3>Year structure</h3>
            <div class="row">
              <div class="col-6">
                <k-radio-button
                  :name="'groupYearStructure'"
                  :value="'financial'"
                  :checked="businessDetails.yearStructure === 0"
                  :label="'Financial Year'"
                  @change="handleYearStructureChange"
                ></k-radio-button>
              </div>
              <div class="col-6">
                <k-radio-button
                  :name="'groupYearStructure'"
                  :value="'calendar'"
                  :checked="businessDetails.yearStructure === 1"
                  :label="'Calendar'"
                  @change="handleYearStructureChange"
                ></k-radio-button>
              </div>
            </div>
          </div>
          <div class="mt-4">
            <p class="m-0">Select the starting month for your profit/loss strategy:</p>
            <div class="form-group mt-3">
              <k-dropdown-list
                  :label="'Start month*'"
                  :data-items="months"
                  :data-item-key="'month'"
                  :text-field="'monthString'"
                  v-model="businessDetails.startMonth"
                  ref="ddlStartMonth"
                  @change="validateStartMonthOnChange"
                  v-kendo-validator="validateStartMonth()" />
            </div>
          </div>
          <div class="mt-4">
            <k-button variant="secondary" @click="next()" class="btn btn-lg btn-secondary w-100 mb-2">
              Next
            </k-button>
            <k-button variant="secondary" @click="back()" class="btn btn-lg btn-outline-primary w-100">
              Back
            </k-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../store";
import kendo from "@progress/kendo-ui"
import { useToast } from "vue-toastification";
import PromptIcon from "@/components/PromptIcon";
import BusinessService from "../../services/business-service";

const toast = useToast();

export default({
  components: {
    PromptIcon,
  },
  name: "business-set-up",
  async beforeCreate() {
    await store.dispatch("loadBusinessIndustries");
    await store.dispatch("initialise");
  },
  computed: {
    industries() {
      return store.getters.industries;
    },
    anyInvalidOnBusinessSetup: function() {
      return this.invalidIndustry || this.invalidBusinessName || this.invalidStartMonth;
    }
  },
  props: {
    businessDetails: {
      default: null,
      type: Object
    }
  },
  data() {
    return {
      invalidIndustry: true,
      invalidStartMonth: true,
      invalidBusinessName: true,
      months: [],
    }
  },
  async mounted() {
    this.loadMonthData();
    this.initializeGSTExempted();
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    validateIndustryOnChange() {
      this.initializeGSTExempted();
      this.validateControl(this.$refs.ddlIndustry.$el);
    },
    validateNameOnChange() {
      this.validateControl(this.$refs.businessNameInput.$el);
    },
    validateStartMonthOnChange() {
      this.validateControl(this.$refs.ddlStartMonth.$el);
    },
    validateControl(control) {
      const validator = kendo.jQuery(control).getKendoValidator();
      validator.validateInput(kendo.jQuery(control)[0].children[0]);
    },
    handleYearStructureChange: function(e) {
        this.businessDetails.yearStructure = e.value;
        this.loadMonthData();
    },
    back() {
      this.$emit("onBack");
    },
    next() {
      this.validateIndustryOnChange();
      this.validateStartMonthOnChange();
      this.validateNameOnChange();

      if (this.anyInvalidOnBusinessSetup) {
        return;
      }

      this.$emit("onNext");
    },
    showAlert(error) {
      console.log("error", error);
      toast.clear();
      toast.error("Something went wrong! Please try again.");
    },
    validateIndustry() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const vm = this;
      return {
        rules: {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          invalid() {
            if (!vm.businessDetails || !vm.businessDetails.businessIndustry || !vm.businessDetails.businessIndustry.businessIndustryID) {
              vm.invalidIndustry = true;
            }
            else {
              vm.invalidIndustry = false;
            }
            return !vm.invalidIndustry;
          }
        },
        messages: {
          invalid: "Required"
        }
      }
    },
    validateStartMonth() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const vm = this;
      return {
        rules: {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          invalid() {
            if (!vm.businessDetails || !vm.businessDetails.startMonth || !vm.businessDetails.startMonth.month) {
              vm.invalidStartMonth = true;
            }
            else {
              vm.invalidStartMonth = false;
            }
            return !vm.invalidStartMonth;
          }
        },
        messages: {
          invalid: "Required"
        }
      }
    },
    validateBusinessName: function () {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const vm = this;
      return {
        rules: {
          required: function () {
            if (!vm.businessDetails || !vm.businessDetails.businessName || vm.businessDetails.businessName.trim() === "") {
                vm.invalidBusinessName = true;
                return false;
            }
            vm.invalidBusinessName = false;
            return true;
          }
        },
        messages: {
          required: "Required"
        }
      }
    },
    async loadMonthData() {
      await BusinessService.getStartMonthOptions()
      .then((response) => {
        this.months = response.monthOptions;
        this.businessDetails.startMonth = response.current;
        this.validateStartMonthOnChange();
      }).catch(this.showAlert);
    },
    initializeGSTExempted() {
        if (this.businessDetails.businessIndustry) {
        this.businessDetails.gstExclusive = this.businessDetails.businessIndustry.incomeTaxExempted;
        if (this.businessDetails.businessIndustry.incomeTaxExempted) {
          this.businessDetails.otherIncomeHasGST = !this.businessDetails.businessIndustry.incomeTaxExempted;
        }
      }
    }
  }
})
</script>
